import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { WhoIsThisForSection } from '../components/WhoIsThisForSection';
import { ProductCard } from '../components/ProductCard';
import { BenefitsSection } from '../components/BenefitsSection';
import { SalesLetter } from '../components/SalesLetter';
import { BundleOffer } from '../components/BundleOffer';
import { TestimonialCard } from '../components/TestimonialCard';
import { FormatsSection } from '../components/FormatsSection';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { Footer } from '../components/Footer';
import { ScrollProgress } from '../components/ScrollProgress';
import { CountdownTimer } from '../components/CountdownTimer';
import { StickyCartButton } from '../components/StickyCartButton';
import { FloatingContactButton } from '../components/FloatingContactButton';
import { FAQSection } from '../components/FAQSection';
import { SocialProofBanner } from '../components/SocialProofBanner';
import { AnimatedSection } from '../components/AnimatedSection';
import { LiveNotifications } from '../components/LiveNotifications';
export function LandingPage() {
  const products = [{
    title: 'Sobrevive a la Quincena',
    description: '50 hacks reales para manejar tu dinero sin sacrificios extremos. El primer paso hacia tu libertad financiera.',
    image: 'https://cdn.magicpatterns.com/uploads/q3FcGqGMwQVZL9GK8NVq6q/ChatGPT_Image_19_dic_2025,_12_22_05.png',
    formats: ['📱'],
    badge: '⭐ PRINCIPAL'
  }, {
    title: '30 Noches para Dormir en Paz',
    description: 'Método Latino Emocionalmente Inteligente para calmar tu mente y sanar la ansiedad.',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/frud4MZfgNuJRqK3nNtUKy/ChatGPT_Image_2_dic_2025%2C_21_43_14.png',
    formats: ['📱'],
    badge: '🎁 BONO GRATIS'
  }, {
    title: 'Glow Up Bichota',
    description: 'Guía para descubrir tu poder femenino y brillar con confianza auténtica.',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/21HbNt2iTtsf4E5L2BWpPV/ChatGPT_Image_17_nov_2025%2C_15_09_22.png',
    formats: ['📱'],
    badge: '🎁 BONO GRATIS'
  }];
  const testimonials = [{
    quote: 'Por primera vez en años, llegué al final de la quincena con dinero en la cuenta. Este método cambió mi relación con el dinero.',
    author: 'Carmen Rodríguez',
    location: 'Houston, TX',
    image: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=100&h=100&fit=crop'
  }, {
    quote: 'Dejé de vivir estresada por el dinero. Ahora sé exactamente a dónde va cada peso y tengo un plan. Me siento en control.',
    author: 'Sofia Martínez',
    location: 'Los Angeles, CA',
    image: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=100&h=100&fit=crop'
  }, {
    quote: 'Pensé que nunca iba a poder ahorrar. Estos hacks son reales y funcionan sin sacrificar mi vida. Ya tengo mi fondo de emergencia.',
    author: 'Ana López',
    location: 'Miami, FL',
    image: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=100&h=100&fit=crop'
  }];
  return <div className="w-full min-h-screen bg-white" data-id="element-374">
      <ScrollProgress data-id="element-375" />
      <CountdownTimer data-id="element-376" />
      <StickyCartButton data-id="element-377" />
      <FloatingContactButton data-id="element-378" />
      <LiveNotifications data-id="element-379" />

      <HeroSection data-id="element-380" />

      <AnimatedSection animation="fade-in" data-id="element-381">
        <WhoIsThisForSection data-id="element-382" />
      </AnimatedSection>

      <AnimatedSection animation="fade-in" data-id="element-383">
        <SocialProofBanner data-id="element-384" />
      </AnimatedSection>

      {/* What's Included Section */}
      <section className="w-full py-20 bg-white" data-id="element-385">
        <div className="max-w-7xl mx-auto px-6" data-id="element-386">
          <AnimatedSection animation="fade-up" data-id="element-387">
            <div className="text-center mb-16" data-id="element-388">
              <h2 className="font-serif text-4xl lg:text-5xl text-navy-900 mb-4" data-id="element-389">
                💰 Qué Incluye Tu Compra
              </h2>
              <p className="text-xl text-gray-600" data-id="element-390">
                El método completo + 2 bonos digitales GRATIS
              </p>
            </div>
          </AnimatedSection>

          <div className="grid md:grid-cols-3 gap-8 max-w-5xl mx-auto" data-id="element-391">
            {products.map((product, index) => <AnimatedSection key={index} animation="fade-up" delay={index * 100} data-id="element-392">
                <ProductCard {...product} data-id="element-393" />
              </AnimatedSection>)}
          </div>

          <AnimatedSection animation="fade-up" delay={400} data-id="element-394">
            <div className="text-center mt-12" data-id="element-395">
              <p className="text-lg text-gray-700 max-w-2xl mx-auto" data-id="element-396">
                <strong className="text-navy-900" data-id="element-397">
                  "Sobrevive a la Quincena"
                </strong>{' '}
                es el producto principal. Los otros 2 eBooks son{' '}
                <strong className="text-emerald-600" data-id="element-398">
                  bonos completamente GRATIS
                </strong>{' '}
                para acelerar tu transformación.
              </p>
            </div>
          </AnimatedSection>
        </div>
      </section>

      <AnimatedSection animation="fade-in" data-id="element-399">
        <BenefitsSection data-id="element-400" />
      </AnimatedSection>

      <AnimatedSection animation="fade-in" data-id="element-401">
        <SalesLetter data-id="element-402" />
      </AnimatedSection>

      <AnimatedSection animation="scale" data-id="element-403">
        <BundleOffer data-id="element-404" />
      </AnimatedSection>

      {/* Testimonials Section */}
      <section className="w-full py-20 bg-gradient-to-b from-white to-emerald-50" data-id="element-405">
        <div className="max-w-7xl mx-auto px-6" data-id="element-406">
          <AnimatedSection animation="fade-up" data-id="element-407">
            <div className="text-center mb-16" data-id="element-408">
              <h2 className="font-serif text-4xl lg:text-5xl text-navy-900 mb-4" data-id="element-409">
                💬 Historias Reales de Transformación
              </h2>
              <p className="text-xl text-gray-600" data-id="element-410">
                Mujeres que tomaron control de sus finanzas
              </p>
            </div>
          </AnimatedSection>

          <div className="grid md:grid-cols-3 gap-8" data-id="element-411">
            {testimonials.map((testimonial, index) => <AnimatedSection key={index} animation="fade-up" delay={index * 150} data-id="element-412">
                <TestimonialCard {...testimonial} data-id="element-413" />
              </AnimatedSection>)}
          </div>
        </div>
      </section>

      <AnimatedSection animation="fade-in" data-id="element-414">
        <FormatsSection data-id="element-415" />
      </AnimatedSection>

      <AnimatedSection animation="fade-in" data-id="element-416">
        <FAQSection data-id="element-417" />
      </AnimatedSection>

      <AnimatedSection animation="fade-in" data-id="element-418">
        <GuaranteeSection data-id="element-419" />
      </AnimatedSection>

      <Footer data-id="element-420" />
    </div>;
}